export const FEATURE_ROUTE = '/features';

export const FAQ_ROUTE = '/faq';

export const BRAND_ASSETS_ROUTE = 'https://www.showsmanager.com/brand-assets/';
